/*
  Slushy calculator: will this mix slush in a Slush-Ease, and on what setting?

  The rules and ingredients live in slush-calculator-data.js (window.SLUSH_DATA).
  evaluate() is the whole decision and touches no page; the rest of this file
  draws the section in sections/slush-calculator.liquid.
*/
(function () {
  var DATA = window.SLUSH_DATA;
  if (!DATA) return;
  var R = DATA.rules;
  var BY_ID = {};
  DATA.ingredients.forEach(function (i) { BY_ID[i.id] = i; });

  // Fluid ounces per unit.
  var UNITS = { oz: 1, cup: 8, Tbsp: 0.5, tsp: 1 / 6, mL: 1 / 29.5735 };
  var UNIT_LABEL = { oz: 'oz', cup: 'cups', Tbsp: 'Tbsp', tsp: 'tsp', mL: 'mL' };
  var STEP = { oz: 1, cup: 0.25, Tbsp: 0.5, tsp: 0.5, mL: 25 };

  /* ---------------- numbers to words ---------------- */

  var FRACTIONS = [[0, ''], [0.25, '¼'], [1 / 3, '⅓'], [0.5, '½'], [2 / 3, '⅔'], [0.75, '¾'], [1, '']];
  // 1.5 → "1½", 0.25 → "¼", 2.4 → "2½" (nearest kitchen fraction)
  function fraction(n) {
    var whole = Math.floor(n + 1e-9), rest = n - whole, best = FRACTIONS[0];
    FRACTIONS.forEach(function (f) { if (Math.abs(rest - f[0]) < Math.abs(rest - best[0])) best = f; });
    if (best[0] === 1) { whole += 1; best = FRACTIONS[0]; }
    return (whole ? String(whole) : (best[1] ? '' : '0')) + best[1];
  }
  // The amount box: kitchen fractions where the amount is one (⅓, 1½, 13½),
  // else up to two decimals.
  function showAmount(n) {
    n = Number(n);
    if (!isFinite(n)) return '';
    var whole = Math.floor(n + 1e-9), rest = n - whole;
    for (var i = 0; i < FRACTIONS.length; i++) {
      if (Math.abs(rest - FRACTIONS[i][0]) < 0.01) {
        if (FRACTIONS[i][0] === 1) return String(whole + 1);
        return (whole || !FRACTIONS[i][1] ? String(whole) : '') + FRACTIONS[i][1];
      }
    }
    return String(Math.round(n * 100) / 100);
  }
  // What someone typed: 2, 1.5, 1,5, ½, 1½, 1/3, 1 1/2. NaN if it isn't an amount.
  var GLYPHS = { '¼': 1 / 4, '½': 1 / 2, '¾': 3 / 4, '⅓': 1 / 3, '⅔': 2 / 3, '⅛': 1 / 8, '⅜': 3 / 8, '⅝': 5 / 8, '⅞': 7 / 8 };
  function readAmount(text) {
    var t = String(text).trim().replace(',', '.'), m, n = NaN;
    if (t === '') return 0;
    if ((m = t.match(/^(\d*\.?\d*)\s*([¼½¾⅓⅔⅛⅜⅝⅞])$/))) n = (m[1] ? Number(m[1]) : 0) + GLYPHS[m[2]];
    else if ((m = t.match(/^(?:(\d+)\s+)?(\d+)\s*\/\s*(\d+)$/))) n = (m[1] ? Number(m[1]) : 0) + (Number(m[3]) ? Number(m[2]) / Number(m[3]) : NaN);
    else if (/^\d*\.?\d+$|^\d+\.$/.test(t)) n = Number(t);
    if (!(n >= 0)) return NaN;
    // 0.33 means ⅓: snap to the kitchen fraction it's next to
    var whole = Math.floor(n), rest = n - whole;
    FRACTIONS.forEach(function (f) { if (Math.abs(rest - f[0]) < 0.005) n = whole + f[0]; });
    return n;
  }
  function oz(n) { return (Math.round(n * 10) / 10).toLocaleString('en-US') + ' oz'; }
  // "12 oz (1½ cups)"
  function ozCups(n) { return n >= 8 ? oz(n) + ' (' + fraction(Math.round(n / 8 * 4) / 4) + ' cup' + (n > 8.5 ? 's' : '') + ')' : oz(n); }
  function tbsp(n) { return fraction(n) + ' Tbsp'; }
  function up(n, step) { return Math.ceil(n / step - 1e-9) * step; }
  // "1½ cups", "8 oz", "2 Tbsp", "250 mL"
  // Sugar, syrups and honey: spoons up to 4 Tbsp (¼ cup), then the cup
  // measures a kitchen has (⅓, ½, ⅔, ¾, 1, then by the ¼ cup).
  var SPOON_MAX = 4;
  var CUP_MEASURES = [1 / 4, 1 / 3, 1 / 2, 2 / 3, 3 / 4, 1];
  // At least this many Tbsp, as the measure you'd reach for: {amount, unit, text}.
  function spoonOrCup(tbspNeeded) {
    if (tbspNeeded <= SPOON_MAX + 1e-9) return { amount: tbspNeeded, unit: 'Tbsp', text: tbsp(tbspNeeded) };
    var c = tbspNeeded / 16, cup = null;
    CUP_MEASURES.forEach(function (m) { if (cup == null && m >= c - 1e-9) cup = m; });
    if (cup == null) cup = up(c, 0.25);
    return { amount: cup, unit: 'cup', text: amountText(cup, 'cup') };
  }
  // The − / + ladder for those, in Tbsp: ½ Tbsp steps to 4, then the cup measures.
  // (Amounts are compared to within 0.02 Tbsp: ⅓ cup is stored as 0.3333.)
  function spoonStep(tbspNow, dir) {
    var ladder = [];
    for (var t = 0; t <= SPOON_MAX; t += 0.5) ladder.push(t);
    CUP_MEASURES.slice(1).forEach(function (m) { ladder.push(m * 16); });
    var top = ladder[ladder.length - 1];
    if (dir > 0) {
      for (var i = 0; i < ladder.length; i++) if (ladder[i] > tbspNow + 0.02) return ladder[i];
      return (Math.floor(tbspNow / 4 + 0.02) + 1) * 4;
    }
    if (tbspNow > top + 0.02) return Math.max(top, (Math.ceil(tbspNow / 4 - 0.02) - 1) * 4);
    for (var j = ladder.length - 1; j >= 0; j--) if (ladder[j] < tbspNow - 0.02) return ladder[j];
    return 0;
  }

  function amountText(n, unit) {
    if (unit === 'cup') return fraction(n) + (n > 1 ? ' cups' : ' cup');
    if (unit === 'oz') return oz(n);
    if (unit === 'mL') return Math.round(n) + ' mL';
    return fraction(n) + ' ' + unit;
  }

  /* ---------------- the decision ---------------- */

  function lookup(item) { return item.custom || BY_ID[item.id]; }

  // The guide's chart of most hard liquor per recipe size (MAX p.14), read
  // between its rows, and in proportion beyond them.
  function spiritLimit(chart, total) {
    if (!chart) return Infinity;
    if (total <= chart[0][0]) return chart[0][1] * total / chart[0][0];
    for (var i = 1; i < chart.length; i++) {
      if (total <= chart[i][0]) {
        var a = chart[i - 1], b = chart[i];
        return a[1] + (b[1] - a[1]) * (total - a[0]) / (b[0] - a[0]);
      }
    }
    var last = chart[chart.length - 1];
    return last[1] * total / last[0];
  }

  // Which setting. Alcohol decides first: whichever kind brings most of it
  // (liquor, wine, beer or seltzer). Straight beer, wine or seltzer keeps its
  // own setting; mixed, it's a cocktail (the original has Wine and Beer
  // presets for those mixes). Without alcohol, the ingredient there's most of
  // that the guides give a setting for; then a coffee-and-milk mix (the
  // guides' frozen latte); then the machine's everyday preset.
  function chooseSetting(machineKey, parts, total) {
    var max = machineKey === 'max';
    var byVol = parts.filter(function (p) { return p.oz > 0; }).sort(function (a, b) { return b.oz - a.oz; });
    var kind = { spirit: 0, wine: 0, beer: 0, seltzer: 0 };
    byVol.forEach(function (p) {
      var k = p.ing.spirit ? 'spirit' : p.ing.wine ? 'wine' : p.ing.beer ? 'beer' : p.ing.abv > 0 ? 'seltzer' : null;
      if (k) kind[k] += p.oz * p.ing.abv;
    });
    var top = Object.keys(kind).sort(function (a, b) { return kind[b] - kind[a]; })[0];
    if (kind[top] > 0) {
      var drink = byVol.filter(function (p) { return p.ing.abv > 0 && !p.ing.spirit; })[0];
      if (top !== 'spirit' && drink && drink.oz / total >= 0.7 && drink.ing[machineKey]) return drink.ing[machineKey];
      if (!max && top === 'wine') return { preset: 'Wine' };
      if (!max && top === 'beer') return { preset: 'Beer' };
      return max ? { preset: 'Cocktail', bars: 5 } : { preset: 'Cocktail' };
    }
    var coffee = false, dairy = false;
    for (var i = 0; i < byVol.length; i++) {
      var ing = byVol[i].ing;
      coffee = coffee || !!ing.coffee; dairy = dairy || !!ing.dairy;
      if (ing.water || ing.minor || ing.mixer) continue;
      if (ing[machineKey]) return ing[machineKey];
    }
    if (coffee && dairy) return max ? { preset: 'Frappe', bars: 5 } : { preset: 'Custom', temp: '29–29.8°F' };
    // The original guide makes its own syrup-and-water slushy on Juice.
    return max ? { preset: 'Slushy', bars: 3 } : { preset: 'Juice' };
  }

  function evaluate(machineKey, items, recipeSetting) {
    var m = DATA.machines[machineKey];
    var parts = [], total = 0, baseOz = 0, sugarG = 0, alcoholOz = 0, spiritOz = 0;
    var flags = {};
    items.forEach(function (item) {
      var ing = lookup(item);
      var amount = Number(item.amount);
      if (!ing || !(amount > 0)) return;
      var unitOz = amount * (UNITS[item.unit] || 1);
      var liquid = ing.dry ? 0 : unitOz;
      var sugar = ing.dry ? (unitOz / 0.5) * (ing.sugarPerTbsp || R.sugarPerTbsp) : unitOz * (ing.sugar || 0);
      parts.push({ ing: ing, item: item, oz: liquid, sugar: sugar });
      total += liquid;
      if (ing.group !== 'Sweeteners') baseOz += liquid;
      sugarG += sugar;
      alcoholOz += liquid * (ing.abv || 0) / 100;
      if (ing.spirit) spiritOz += liquid;
      ['dairy', 'beer', 'protein', 'diet', 'coffee', 'allulose', 'wine', 'spirit'].forEach(function (f) { if (ing[f]) flags[f] = true; });
      if (ing.id === 'hard-seltzer') flags.seltzer = true;
      if (ing.id === 'seltzer' && liquid > 0) flags.clubSoda = true;
      if (!ing.water && !(ing.dry) && (ing.sugar > 0 || ing.abv > 0)) flags.flavor = true;
      if (ing.dry || ing.sugar > 0) flags.sweet = true;
    });

    var out = { status: 'empty', machine: m, total: total, sugarPerOz: 0, abv: 0, fixes: [], fill: null, tips: [], setting: null };
    if (!parts.length) return out;

    // The guides' sugar rule is per ounce of the drink itself (1 g per oz on
    // its label); sugar and syrups stirred in make up the shortfall rather
    // than count as more drink to sweeten. It's how the MAX guide's allulose
    // chart works out (8 oz of diet soda → ½ Tbsp).
    var sweetenOz = baseOz || total;
    out.sugarPerOz = sweetenOz ? sugarG / sweetenOz : 0;
    out.abv = total ? alcoholOz / total * 100 : 0;
    var alcoholHelps = out.abv >= R.alcoholCountsFrom;

    // Each fix says what to do, in a sentence; where adding something fixes
    // it, an action the page can turn into an "Add it" button.
    function fix(text, actions) {
      actions = actions || [];
      var roomy = actions.filter(function (a) { return a.madeRoom; }).length;
      if (roomy) text += roomy === actions.length ? ' Your tank is full, so pour a little out first to make room.'
        : ' Sugar doesn’t need room, but the syrup does: with a full tank, pour a little out first.';
      out.fixes.push({ text: text, actions: actions });
    }
    var water = function (ozAmount) { return { id: 'water', amount: up(ozAmount, 1), unit: 'oz', label: 'Add ' + oz(up(ozAmount, 1)) + ' water' }; };
    var minOz = m.minOz, maxOz = m.maxOz;
    // A fix that adds liquid to a full tank: pour out just enough of the mix
    // first. (a.scale is how much of the mix to keep; the button applies it.)
    // Past the tank already, the "How much to pour" note covers it instead.
    function makeRoom(a, addOz) {
      if (total > maxOz + 1 || total + addOz <= maxOz + 1) return a;
      var pour = Math.min(total, up(total + addOz - maxOz, 1));
      a.scale = (total - pour) / total;
      a.madeRoom = true;
      a.label = 'Pour out ' + oz(pour) + ', then ' + a.label.charAt(0).toLowerCase() + a.label.slice(1);
      return a;
    }

    // Won't slush, whatever the setting.
    if (!flags.sweet && !alcoholHelps && parts.every(function (p) { return p.ing.water || p.oz === 0; })) {
      out.status = 'no';
      out.headline = flags.clubSoda ? 'Plain club soda or seltzer won’t slush.' : 'Plain water won’t slush.';
      out.why = 'Without sugar it freezes solid, and running the machine on plain water can damage it. Use a sweetened drink, or add syrup.';
      var syrup = spoonOrCup(up(sweetenOz * R.sugarPerOz / R.simpleSyrupPerTbsp, 0.5));
      if (total > 0) fix('Add sweetener so it can slush.', [makeRoom({ id: 'simple-syrup', amount: syrup.amount, unit: syrup.unit, label: 'Add ' + syrup.text + ' simple syrup' }, syrup.amount * UNITS[syrup.unit])]);
      return out;
    }
    if (flags.protein && machineKey === 'orig') {
      out.status = 'no';
      out.headline = 'Protein shakes won’t slush in this machine.';
      out.why = 'They’re high in protein and low in sugar, so they freeze unevenly and can cause problems with the Slush-Ease. The Slush-Ease MAX has a Shake setting for them.';
      return out;
    }

    // How much to pour. The tank's limits are about running the machine, not
    // whether the drink slushes, so they're a note beside the answer, never
    // the reason for it.
    if (total < minOz - 0.25) {
      // One tap tops it up with more of the main drink, in the unit it's measured in.
      var main = parts.filter(function (p) { return p.oz > 0 && !p.ing.water && !p.ing.spirit && !p.ing.minor && !p.item.custom; })
        .sort(function (a, b) { return b.oz - a.oz; })[0];
      var more = [];
      if (main) {
        var u = main.item.unit, amt = up((minOz - total) / (UNITS[u] || 1), STEP[u] || 1);
        more.push({ id: main.ing.id, amount: amt, unit: u, label: 'Add ' + amountText(amt, u) + ' more ' + main.ing.name.toLowerCase() });
      }
      out.fill = { text: 'The ' + m.name + ' needs at least ' + ozCups(minOz) + ' to run. Make ' + oz(minOz - total) + ' more.', actions: more };
    } else if (total > maxOz + 1) { // the guide's own margarita comes to 64.7 oz
      out.fill = { text: 'The tank holds ' + ozCups(maxOz) + '. Pour that much and keep the rest cold for a second batch.', actions: [] };
    }

    // Too strong: over 16% alcohol, or (on the MAX) more liquor than its chart
    // allows for this much drink. One fix covers both: the least water that
    // brings it within both limits.
    var strong = function (t) { return alcoholOz / t * 100 > R.maxAbv + 1e-9 || spiritOz > spiritLimit(m.spirits, t) + 0.25; };
    if (strong(total)) {
      var target = null;
      for (var t = Math.ceil(total); t <= total * 20 + 64; t += 1) { if (!strong(t)) { target = t; break; } }
      var keep = null;
      if (target != null && target > maxOz + 1 && total <= maxOz + 1) {
        // No room for that much water: keep as much of the mix as still
        // slushes once it's topped up with water to the tank's limit.
        for (var k = Math.floor(Math.min(total, maxOz)); k >= 1; k -= 1) {
          if (!(alcoholOz * k / total / maxOz * 100 > R.maxAbv + 1e-9 || spiritOz * k / total > spiritLimit(m.spirits, maxOz) + 0.25)) { keep = k; break; }
        }
      }
      if (keep != null) fix('Too strong to slush, and the tank holds ' + ozCups(maxOz) + '. Pour out ' + oz(total - keep) + ' of the mix, then add ' + oz(maxOz - keep) + ' of water.',
        [{ id: 'water', amount: maxOz - keep, unit: 'oz', scale: keep / total, label: 'Pour out ' + oz(total - keep) + ', then add ' + oz(maxOz - keep) + ' water' }]);
      else if (target != null) fix('Too strong to slush. Add ' + ozCups(target - total) + ' of water, juice, soda or mixer.', [water(target - total)]);
      else fix('Too strong to slush. Use less alcohol.');
    }

    if (!alcoholHelps && out.sugarPerOz < R.sugarPerOz) {
      var short = sweetenOz * R.sugarPerOz - sugarG;
      var sug = spoonOrCup(up(short / R.sugarPerTbsp, 0.25)), all = spoonOrCup(up(short / R.allulosePerTbsp, 0.5));
      fix((flags.diet ? 'Diet and unsweetened drinks need sugar to slush.' : 'Not sweet enough to slush.') +
        ' Stir in sugar until it dissolves, or use allulose syrup (the only sugar substitute that works).',
        [{ id: 'sugar', amount: sug.amount, unit: sug.unit, label: 'Add ' + sug.text + ' sugar' },
         makeRoom({ id: 'allulose', amount: all.amount, unit: all.unit, label: 'Add ' + all.text + ' allulose syrup' }, all.amount * UNITS[all.unit])]);
    }

    out.status = out.fixes.length ? 'tweak' : 'ok';
    out.headline = out.status === 'ok' ? 'This will slush.' : out.fixes.length === 1 ? 'One change and it will slush.' : out.fixes.length + ' changes and it will slush.';

    // The setting.
    var s = recipeSetting || chooseSetting(machineKey, parts, total || 1);
    s = { preset: s.preset, bars: s.bars, level: s.level, temp: s.temp };
    if (machineKey === 'max' && flags.allulose && s.bars > 1 && !recipeSetting) {
      s.bars -= 1;
      out.tips.push('With allulose it’s one bar lower than usual.');
    }
    out.setting = s;

    // A few things worth knowing, most important first.
    if (machineKey === 'max' && (s.preset === 'Shake' || s.preset === 'Frappe')) out.tips.push('Serve it as soon as it’s ready. Shakes and frappes turn foamy if they sit.');
    if (m.foamOz && (flags.dairy || flags.beer) && total > m.foamOz) out.tips.push('Milk and beer foam up. The first time, fill to ' + oz(m.foamOz) + ' at most.');
    if (flags.protein && machineKey === 'max') out.tips.push('Artificially sweetened shake? Add sugar or allulose syrup.');
    // How sweet it really is in the tank (syrups included), unlike the sugar rule.
    if (total && sugarG / total > R.sweetTipPerOz) out.tips.push('Very sweet mixes can come out thin. If it does, turn the thickness up a notch, or add a little water.');
    out.tips.push('Start with a cold or room-temperature drink, never warm.');
    out.tips.push('Too thick? ' + m.thinner + '. Too thin? Turn the thickness up a notch.');
    return out;
  }

  // For tests (node): module.exports.
  if (typeof module !== 'undefined' && module.exports) module.exports = { evaluate: evaluate, spiritLimit: spiritLimit, fraction: fraction, showAmount: showAmount, readAmount: readAmount, UNITS: UNITS };

  /* ---------------- the page ---------------- */

  if (typeof document === 'undefined') return;
  var root = document.querySelector('[data-slush-calculator]');
  if (!root) return;

  var state = { machine: null, items: [], uid: 0, customs: 0 };
  var $ = function (sel) { return root.querySelector(sel); };
  var list = $('.slush-items'), search = $('#slush-search'), options = $('#slush-options');
  var result = $('.slush-result'), bar = $('.slush-bar');

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function unitsFor(ing) { return ing.dry ? ['Tbsp', 'cup', 'tsp'] : ['cup', 'oz', 'Tbsp', 'mL']; }

  // A starting amount that already makes sense: the first drink fills the
  // smallest batch the tank runs (2 cups), liquor starts at ½ cup, sweeteners
  // at 2 Tbsp, anything else at a cup.
  function defaultAmount(ing) {
    if (ing.unit === 'Tbsp') return 2;
    if (ing.spirit) return 0.5;
    var hasDrink = state.items.some(function (i) { var x = lookup(i); return x && !x.dry && !x.minor && !x.water; });
    if (!ing.dry && !ing.minor && !ing.water && !hasDrink) return 2;
    return 1;
  }

  // Add an ingredient. Each one is listed once: picking it again (chip or
  // search) just points to its row; a fix button adds its amount to the row,
  // in whichever of the two units is finer (¾ Tbsp sugar onto ¼ cup → 4¾ Tbsp).
  function add(id, amount, unit, custom) {
    var ing = custom || BY_ID[id];
    if (!ing) return;
    unit = unit || ing.unit || 'cup';
    var same = !custom && state.items.filter(function (i) { return i.id === id; })[0];
    if (same && amount == null) { flash(same, true); return; }
    if (same) {
      var have = Number(same.amount) * UNITS[same.unit];
      if (UNITS[unit] < UNITS[same.unit]) same.unit = unit;
      same.amount = Math.round((have + amount * UNITS[unit]) / UNITS[same.unit] * 100) / 100;
      if (ing.unit === 'Tbsp' && same.unit === 'Tbsp' && same.amount > SPOON_MAX) {
        same.unit = 'cup'; same.amount = Math.round(same.amount / 16 * 100) / 100;
      }
    } else {
      state.items.push({ uid: ++state.uid, id: ing.id, custom: custom || null, amount: amount != null ? amount : defaultAmount(ing), unit: unit });
    }
    draw();
    flash(same || state.items[state.items.length - 1]);
  }
  // Light up a row (and bring it into view when it's one already listed).
  function flash(it, show) {
    var row = list.querySelector('[data-uid="' + it.uid + '"]');
    if (!row) return;
    row.classList.remove('is-new'); void row.offsetWidth; row.classList.add('is-new');
    if (show) {
      var r = row.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) row.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  // After a row goes, keep keyboard and screen-reader users in place without
  // focusing the search box (on a phone that pops the keyboard up): the
  // remove button of the row that took its place, or the one before, or
  // the step's heading once the list is empty.
  function settleFocus(at) {
    var removes = list.querySelectorAll('.slush-remove');
    var next = removes[Math.min(at, removes.length - 1)] || $('#slush-step-2');
    next.focus({ preventScroll: true });
  }

  function draw() {
    list.innerHTML = state.items.map(function (it) {
      var ing = lookup(it);
      return '<li class="slush-item" data-uid="' + it.uid + '">' +
        '<span class="slush-item__name">' + esc(ing.name) + '</span>' +
        '<span class="slush-item__qty">' +
          '<button type="button" class="slush-step" data-step="-1" aria-label="Less ' + esc(ing.name) + '">−</button>' +
          '<input type="text" inputmode="decimal" autocomplete="off" enterkeyhint="done" value="' + showAmount(it.amount) + '" aria-label="How much ' + esc(ing.name) + '" id="slush-amt-' + it.uid + '">' +
          '<button type="button" class="slush-step" data-step="1" aria-label="More ' + esc(ing.name) + '">+</button>' +
          '<select aria-label="Unit for ' + esc(ing.name) + '" id="slush-unit-' + it.uid + '">' + unitsFor(ing).map(function (u) {
            return '<option value="' + u + '"' + (u === it.unit ? ' selected' : '') + '>' + UNIT_LABEL[u] + '</option>';
          }).join('') + '</select>' +
        '</span>' +
        '<button type="button" class="slush-remove" aria-label="Remove ' + esc(ing.name) + '">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '</li>';
    }).join('');
    root.classList.toggle('has-items', state.items.length > 0);
    // Chips for what's already in: a check instead of a plus.
    if (quick) quick.querySelectorAll('[data-quick]').forEach(function (b) {
      var on = state.items.some(function (i) { return i.id === b.dataset.quick; });
      b.classList.toggle('is-added', on);
      b.querySelector('.slush-chip__sign').textContent = on ? '✓' : '+';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    update();
  }

  function item(el) { var uid = Number(el.closest('[data-uid]').dataset.uid); return state.items.filter(function (i) { return i.uid === uid; })[0]; }
  // Typing updates the answer as you go; leaving the box tidies it (0.33 → ⅓).
  list.addEventListener('input', function (e) {
    if (!e.target.matches('input')) return;
    var n = readAmount(e.target.value);
    e.target.setAttribute('aria-invalid', isNaN(n) ? 'true' : 'false');
    if (!isNaN(n)) { item(e.target).amount = n; update(); }
  });
  list.addEventListener('change', function (e) {
    if (e.target.matches('input')) {
      e.target.value = showAmount(item(e.target).amount);
      e.target.setAttribute('aria-invalid', 'false');
      return;
    }
    if (!e.target.matches('select')) return;
    var it = item(e.target), before = it.amount * UNITS[it.unit];
    it.unit = e.target.value;
    // The same amount, in the new unit.
    it.amount = Math.max(STEP[it.unit], Math.round(before / UNITS[it.unit] / STEP[it.unit]) * STEP[it.unit]);
    draw();
  });
  list.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    var it = item(b);
    if (b.classList.contains('slush-remove')) {
      var at = state.items.indexOf(it);
      state.items = state.items.filter(function (i) { return i !== it; });
      draw(); settleFocus(at);
      return;
    }
    var dir = Number(b.dataset.step), ing = lookup(it);
    if (ing.unit === 'Tbsp' && (it.unit === 'Tbsp' || it.unit === 'cup')) {
      // spoons to 4 Tbsp, then cups; the row redraws for the unit, and the
      // same button keeps focus
      var next = spoonStep(Number(it.amount) * UNITS[it.unit] / UNITS.Tbsp, dir);
      if (next > SPOON_MAX + 1e-9) { it.unit = 'cup'; it.amount = Math.round(next / 16 * 10000) / 10000; }
      else { it.unit = 'Tbsp'; it.amount = next; }
      draw();
      var again = list.querySelector('[data-uid="' + it.uid + '"] [data-step="' + dir + '"]');
      if (again) again.focus({ preventScroll: true });
      return;
    }
    it.amount = Math.max(0, Math.round((Number(it.amount) + dir * STEP[it.unit]) * 100) / 100);
    b.parentNode.querySelector('input').value = showAmount(it.amount);
    update();
  });

  /* the search box: a combobox over the ingredients */
  var matches = [], active = -1;
  function norm(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function setActive(n) {
    active = n;
    [].forEach.call(options.children, function (li, i) { li.setAttribute('aria-selected', i === n ? 'true' : 'false'); });
    if (n >= 0) search.setAttribute('aria-activedescendant', 'slush-opt-' + n); else search.removeAttribute('aria-activedescendant');
  }
  function showOptions() {
    var words = norm(search.value.trim()).split(/\s+/).filter(Boolean);
    if (!words.length) { closeOptions(); return; }
    matches = DATA.ingredients.filter(function (i) {
      var hay = norm(i.name + ' ' + i.aliases);
      return words.every(function (w) { return hay.indexOf(w) >= 0; });
    }).slice(0, 7);
    options.innerHTML = matches.map(function (i, n) {
      return '<li role="option" id="slush-opt-' + n + '" data-n="' + n + '">' + esc(i.name) + '</li>';
    }).join('') || '<li class="slush-none">No match. Try another word, or use “Can’t find your drink?” below.</li>';
    options.hidden = false;
    search.setAttribute('aria-expanded', 'true');
    setActive(matches.length ? 0 : -1);
  }
  function closeOptions() { options.hidden = true; search.setAttribute('aria-expanded', 'false'); search.removeAttribute('aria-activedescendant'); }
  function pick(n) { if (!matches[n]) return; search.value = ''; closeOptions(); add(matches[n].id); }
  search.addEventListener('input', showOptions);
  search.addEventListener('focus', function () { if (search.value) showOptions(); });
  // Enter never submits the search form; it picks the highlighted drink.
  $('.slush-search').addEventListener('submit', function (e) { e.preventDefault(); });
  search.addEventListener('keydown', function (e) {
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && matches.length) {
      e.preventDefault();
      if (options.hidden) showOptions();
      setActive((active + (e.key === 'ArrowDown' ? 1 : -1) + matches.length) % matches.length);
    } else if (e.key === 'Enter' && !options.hidden && active >= 0) { e.preventDefault(); pick(active); }
    else if (e.key === 'Escape') closeOptions();
  });
  options.addEventListener('mousedown', function (e) { e.preventDefault(); });
  options.addEventListener('click', function (e) { var li = e.target.closest('[data-n]'); if (li) pick(Number(li.dataset.n)); });
  search.addEventListener('blur', function () { setTimeout(closeOptions, 150); });

  // One-tap buttons for the drinks people slush most.
  var quick = $('.slush-quick');
  quick.innerHTML = DATA.popular.map(function (id) { return '<button type="button" class="slush-chip" data-quick="' + id + '" aria-pressed="false"><span class="slush-chip__sign" aria-hidden="true">+</span> ' + esc(BY_ID[id].name) + '</button>'; }).join('');
  // A chip toggles: tap to add, tap again to take it out.
  quick.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick]');
    if (!b) return;
    var id = b.dataset.quick;
    if (state.items.some(function (i) { return i.id === id; })) {
      state.items = state.items.filter(function (i) { return i.id !== id; });
      draw();
    } else add(id);
  });

  /* a drink that isn't on the list, from its nutrition label */
  var label = $('.slush-label'), labelForm = label.querySelector('form');
  labelForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = labelForm.elements;
    var serving = Number(f['slush-label-serving'].value), sugar = Number(f['slush-label-sugar'].value);
    if (!(serving > 0)) { f['slush-label-serving'].focus(); return; }
    if (!(sugar >= 0) || f['slush-label-sugar'].value === '') { f['slush-label-sugar'].focus(); return; }
    var custom = {
      id: 'custom-' + (++state.customs), custom: true,
      name: f['slush-label-name'].value.trim() || 'My drink',
      sugar: sugar / serving, abv: Number(f['slush-label-abv'].value) || 0,
      dairy: f['slush-label-dairy'].checked, protein: f['slush-label-protein'].checked
    };
    add(custom.id, 1, 'cup', custom);
    labelForm.reset();
    label.open = false;
  });

  /* machine */
  // Picking a machine swaps step 1 for steps 2 and 3 (and a Back button);
  // bring the top of them into view if the swap left it off screen.
  function reveal() {
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.classList.add('is-revealing');
    setTimeout(function () { root.classList.remove('is-revealing'); }, 400);
    var back = $('.slush-back'), top = back.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.75) back.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
  }

  // Back to step 1. What's in the list stays, for whichever machine is picked next.
  $('.slush-back').addEventListener('click', function () {
    root.querySelectorAll('input[name="slush-machine"]').forEach(function (r) { r.checked = false; });
    state.machine = null;
    delete root.dataset.machine;
    update();
    var pick = $('.slush-pick');
    if (pick.getBoundingClientRect().top < 0) pick.scrollIntoView({ block: 'start' });
    var first = root.querySelector('input[name="slush-machine"]');
    if (first) first.focus({ preventScroll: true });
  });

  root.querySelectorAll('input[name="slush-machine"]').forEach(function (r) {
    r.addEventListener('change', function () {
      state.machine = r.value;
      root.dataset.machine = r.value;
      update();
      reveal();
    });
  });
  $('.slush-clear').addEventListener('click', function () { state.items = []; draw(); settleFocus(0); });

  /* the answer */
  var BADGE = { ok: 'Will slush', tweak: 'Needs a tweak', no: 'Won’t slush', empty: 'Add your drink', pick: 'Pick your machine' };
  var ICON = {
    ok: '<path d="M5 12.5l4.5 4.5L19 7.5"/>', tweak: '<path d="M12 7v6M12 16.5v.5"/>', no: '<path d="M7 7l10 10M17 7L7 17"/>',
    empty: '<path d="M12 7v10M7 12h10"/>', pick: '<path d="M8 12h8M13 8l4 4-4 4"/>'
  };
  // The answer's headline carries the verdict; a round mark in front of it
  // (✓, !, ✕) gives it at a glance. The phone bar keeps the worded badge.
  function headline(st, text) {
    return '<h3 class="slush-headline"><span class="slush-mark"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICON[st] + '</svg></span><span>' + esc(text) + '</span></h3>';
  }
  function badge(st) { return '<span class="slush-badge"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICON[st] + '</svg>' + BADGE[st] + '</span>'; }

  function settingHtml(s, m) {
    var thick;
    if (m.thickness.kind === 'bars') {
      var lit = '';
      for (var i = 1; i <= m.thickness.of; i++) lit += '<i' + (i <= s.bars ? ' class="on"' : '') + '></i>';
      thick = '<div class="slush-tile"><span class="slush-tile__label">Thickness</span><span class="slush-tile__value">' + s.bars + ' bar' + (s.bars === 1 ? '' : 's') + '</span>' +
        '<span class="slush-bars" role="img" aria-label="' + s.bars + ' of ' + m.thickness.of + ' bars lit">' + lit + '</span></div>';
    } else if (s.temp) {
      thick = '<div class="slush-tile"><span class="slush-tile__label">Temperature</span><span class="slush-tile__value">' + esc(s.temp) + '</span><span class="slush-tile__hint">Set it with Thickness + and −</span></div>';
    } else if (s.level) {
      thick = '<div class="slush-tile"><span class="slush-tile__label">Thickness</span><span class="slush-tile__value">All the way up</span><span class="slush-tile__hint">Press Thickness + until it stops</span></div>';
    } else {
      thick = '<div class="slush-tile"><span class="slush-tile__label">Thickness</span><span class="slush-tile__value">Leave it</span><span class="slush-tile__hint">The preset sets it for you</span></div>';
    }
    return '<div class="slush-settings"><div class="slush-tile slush-tile--preset"><span class="slush-tile__label">Press</span><span class="slush-tile__value">' + esc(s.preset) + '</span><span class="slush-tile__hint">' +
      (s.preset === 'Custom' ? 'Then set the temperature' : 'Then press Start') + '</span></div>' + thick + '</div>';
  }

  // "Slush-Ease MAX user guide", linked to the PDF: the product's own guide
  // link if it has one, else the one on file.
  function guideLink(m) {
    var radio = root.querySelector('#slush-machine-' + state.machine);
    var url = (radio && radio.dataset.guide) || m.guide;
    var label = esc(m.name) + ' user guide';
    return url ? '<a href="' + esc(url) + '" target="_blank" rel="noopener">' + label + '<span class="sr-only"> (PDF, opens in a new tab)</span></a>' : label;
  }

  function update() {
    var m = state.machine && DATA.machines[state.machine];
    var r = m ? evaluate(state.machine, state.items) : null;
    var st = !state.items.length ? 'empty' : !m ? 'pick' : r.status;
    if (root.dataset.status === 'empty' && st !== 'empty') {
      // Step 3 shows up with the first ingredient.
      root.classList.add('answer-arriving');
      setTimeout(function () { root.classList.remove('answer-arriving'); }, 400);
    }
    root.dataset.status = st;
    var html = '';
    if (st === 'empty') {
      html += headline(st, 'What are you slushing?') + '<p class="slush-why">Add your drink above, and how much. You’ll see right here if it will slush and what to press.</p>';
    } else if (st === 'pick') {
      html += headline(st, 'Which machine do you have?') + '<p class="slush-why">Pick it at the top. The settings are different on each one.</p>';
    } else {
      html += headline(st, r.headline) + (r.why ? '<p class="slush-why">' + esc(r.why) + '</p>' : '');
      if (r.fixes.length) {
        html += '<ol class="slush-fixes">' + r.fixes.map(function (f) {
          return '<li><span>' + esc(f.text) + '</span>' + (f.actions.length ? '<span class="slush-fix-actions">' + f.actions.map(function (a) {
            return '<button type="button" class="slush-add" data-add="' + a.id + '|' + a.amount + '|' + a.unit + (a.scale != null ? '|' + a.scale : '') + '">' + esc(a.label) + '</button>';
          }).join('<span class="slush-or">or</span>') + '</span>' : '') + '</li>';
        }).join('') + '</ol>';
      }
      if (r.fill) html += '<div class="slush-fill"><p><strong>How much to pour:</strong> ' + esc(r.fill.text) + '</p>' + (r.fill.actions.length ? '<span class="slush-fix-actions">' + r.fill.actions.map(function (a) {
        return '<button type="button" class="slush-add" data-add="' + a.id + '|' + a.amount + '|' + a.unit + (a.scale != null ? '|' + a.scale : '') + '">' + esc(a.label) + '</button>';
      }).join('') + '</span>' : '') + '</div>';
      if (r.setting) html += '<h4 class="slush-sub">' + (r.status === 'ok' ? 'On your ' + esc(m.name) : 'Once it’s fixed') + '</h4>' + settingHtml(r.setting, m);
      if (r.tips.length) html += '<ul class="slush-tips">' + r.tips.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
      html += '<details class="slush-how"><summary>How we worked this out</summary><dl>' +
        '<div><dt>Amount</dt><dd>' + ozCups(r.total) + '</dd><dd class="slush-need">The tank takes ' + m.minOz + '–' + m.maxOz + ' oz</dd></div>' +
        '<div><dt>Sugar</dt><dd>' + (Math.round(r.sugarPerOz * 10) / 10) + ' g per oz</dd><dd class="slush-need">' + (r.abv >= R.alcoholCountsFrom ? 'Not needed: the alcohol keeps it from freezing solid' : 'Needs 1 g per oz or more') + '</dd></div>' +
        '<div><dt>Alcohol</dt><dd>' + (Math.round(r.abv * 10) / 10) + '%</dd><dd class="slush-need">16% at most</dd></div>' +
        '</dl><p>From the ' + guideLink(m) + '.</p></details>';
    }
    result.innerHTML = html;
    var setting = r && r.setting && st !== 'no' ? ' · ' + r.setting.preset + (r.setting.bars ? ', ' + r.setting.bars + ' bars' : r.setting.temp ? ', ' + r.setting.temp : '') : '';
    bar.querySelector('.slush-bar__text').innerHTML = badge(st) + '<span>' + esc(st === 'ok' ? setting.replace(' · ', '') : '') + '</span>';
  }

  result.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b) return;
    var p = b.dataset.add.split('|');
    // "Pour out some, then add…": shrink everything in the list to what's kept first.
    // What's left is already mixed in the tank, so liquids read in ounces to the
    // half ounce (13.5 oz, not 1.69 cups); spoon measures stay in spoons.
    if (p[3]) state.items.forEach(function (i) {
      var kept = Number(i.amount) * Number(p[3]);
      if (i.unit === 'Tbsp' || i.unit === 'tsp') i.amount = Math.round(kept * 4) / 4;
      else { i.amount = Math.round(kept * (UNITS[i.unit] || 1) * 2) / 2; i.unit = 'oz'; }
    });
    add(p[0], Number(p[1]), p[2]);
    result.focus({ preventScroll: true });
  });

  // On a phone the answer sits below the list, so a bar at the bottom of the
  // screen carries it while the answer is out of sight.
  bar.querySelector('button').addEventListener('click', function () {
    result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    result.focus({ preventScroll: true });
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { root.classList.toggle('answer-in-view', es[0].isIntersecting); }, { threshold: 0.1 }).observe(result);
  }

  // A machine the browser kept picked (back button, reload) counts as picked.
  // Or the one a Slush-Ease product page linked here with (?machine=max|orig).
  var asked = (location.search.match(/[?&]machine=(max|orig)\b/) || [])[1];
  var askedRadio = asked && root.querySelector('#slush-machine-' + asked);
  if (askedRadio) askedRadio.checked = true;
  var kept = root.querySelector('input[name="slush-machine"]:checked');
  if (kept) { state.machine = kept.value; root.dataset.machine = kept.value; }
  draw();
})();
